import {
  ORIGINAL_SIZE,
  renditionKey,
  s3PublicBaseUrl,
  type ServedSize,
} from '@brickup/shared/utils'

/** Where every uploaded file is served from. Exported because a derivative's
 *  key is stored whole and only needs the host in front of it. */
export const S3_PUBLIC_BASE_URL = s3PublicBaseUrl(
  import.meta.env.VITE_UPLOADS_BUCKET,
)

/** The derivatives that are delivered, plus the original an asset whose
 *  ladder is gone falls back to. */
export type S3ImageSize = ServedSize | typeof ORIGINAL_SIZE

type S3ImageParams = {
  uuid: string
  path: string
  format: string
  size?: S3ImageSize
}

export function getS3ImageUrl({
  size = 'lg',
  ...asset
}: S3ImageParams): string {
  return `${S3_PUBLIC_BASE_URL}/${renditionKey(asset, size)}`
}
